import React, { useState } from "react";
import { Button } from "@mui/material";
import { Card } from "@mui/material";
import { Trash, AlertCircle, MessageSquare, Calendar, Bell } from "lucide-react";
import TotalData from '../../data/TotalData.json'
const notificationsData = [
  {
    id: 1,
    title: "Meeting at 07:30 PM.",
    description: "You have an upcoming meeting with Alex regarding digital marketing.",
    type: "meeting",
    status: "new",
    date: "",
  },
  {
    id: 2,
    title: "New Session booked by Anthony M.",
    description: "New session is booked by Anthony, on 27th January at 05:30 PM.",
    type: "session",
    status: "new",
    date: "",
  },
  {
    id: 3,
    title: "Error processing payment!",
    description: "Please review the wallet details and fix the error to process your payments.",
    type: "error",
    status: "new",
    date: "",
  },
  {
    id: 4,
    title: "You have a new message from Luke.",
    description: "You have a new message in conversations from Luke Wield.",
    type: "message",
    status: "read",
    date: "24/12/2022",
  },
  {
    id: 5,
    title: "Meeting at 06:45 PM.",
    description: "You have a meeting with Lauren regarding career navigation.",
    type: "meeting",
    status: "read",
    date: "13/12/2022",
  },
];

const NotificationItem = ({ notification, onDelete }) => {
  const icons = {
    meeting: <Calendar className="text-green-500" />,
    session: <Calendar className="text-green-500" />,
    error: <AlertCircle className="text-red-500" />,
    message: <Bell className="text-blue-500" />,
  };

  return (
    <Card style={{width:"100%"}} className="flex  justify-between p-4 mb-2 border rounded-lg shadow-sm">
      <div className="flex gap-3">
       <span className="p-2"> {icons["message"]}</span>
        <div>
          <h4 className="font-semibold"> <a href={`/dashboard?name=${notification.ModuleName}&&details=${notification.PrimaryType}&&particulars=${notification.Particulars}&&node=${notification.SecondaryType}`}>{notification.Particulars}</a> </h4>
          <p className="text-gray-600 text-sm">{notification.KeyInsights}</p>
          <div className="flex gap-3">
            <span style={{background:"#eee",padding:"5px",borderRadius:"5px",fontSize:"12px"}}>{notification.RowType}</span>
            <span style={{background:"#eee",padding:"5px",borderRadius:"5px",fontSize:"12px"}}>{notification.Status}</span>
            <span style={{background:"#eee",padding:"5px",borderRadius:"5px",fontSize:"12px"}}>{notification.PrimaryType}</span>
            <span style={{background:"#eee",padding:"5px",borderRadius:"5px",fontSize:"12px"}}>{notification.SecondaryType}</span>


          </div>

        </div>
      </div>
      <div className="flex items-center gap-2">
        {notification.Status === "To be reviewed" && (
          <span className="bg-green-100 text-green-700 text-xs font-semibold px-2 py-1 rounded-lg">New</span>
        )}
        <Button variant="ghost" size="icon" onClick={() => onDelete(notification.id)}>
          <Trash className="text-red-400" />
        </Button>
      </div>
    </Card>
  );
};

const NotificationLandingpage = () => {
  const [notifications, setNotifications] = useState(notificationsData);
  const [data,setData] = useState(TotalData)

  const handleDelete = (id) => {
    setNotifications(notifications.filter((n) => n.id !== id));
  };

  const readyToReview = data && data.filter((item)=> item.Status === 'To be reviewed')
  return (
    <div className="mx-auto p-6">
      <h2 className="text-xl font-bold mb-4 p-1">Notifications</h2>
      <div>
        {readyToReview.map((notification,index) => (
          <NotificationItem key={index} notification={notification} onDelete={handleDelete} />
        ))}
      </div>
    </div>
  );
};

export default NotificationLandingpage;
